import axios from 'axios';
import { API_URL } from '../variables';
import { getHeaders } from './login';
import { mapProduct } from './mapApiInterface';

//  CHECKOUT

function checkDeliveryOptions() {
  return axios
    .get(`${API_URL}/orders/delivery-methods`, getHeaders())
    .then(({ data }) => data);
}

function checkDeliveryCost(zipCode, customerId) {
  return axios
    .post(
      `${API_URL}/orders/delivery-cost`,
      { zipCode, customerId },
      getHeaders()
    )
    .then((data) => data);
}

function confirmOrder(orderDetails) {
  return axios
    .post(`${API_URL}/orders/create`, orderDetails, getHeaders())
    .then((data) => data);
}

//  CART

function updateCartProducts(products, customerId) {
  return axios
    .post(`${API_URL}/cart/update`, { products, customerId }, getHeaders())
    .then(({ data: { cart } }) => ({
      ...cart,
      cart_items: cart.cart_items.map((product) => mapProduct(product)),
    }));
}

function removeProductFromCart(reference, customerId) {
  return axios
    .post(`${API_URL}/cart/remove`, { reference, customerId }, getHeaders())
    .then(({ data: { cart } }) => ({
      ...cart,
      cart_items: cart.cart_items.map((product) => mapProduct(product)),
    }));
}

function applyDiscount(reference, discount) {
  return axios
    .post(`${API_URL}/cart/remove`, { reference, discount }, getHeaders())
    .then(({ data: { cart } }) => cart);
}

export {
  checkDeliveryOptions,
  updateCartProducts,
  applyDiscount,
  removeProductFromCart,
  checkDeliveryCost,
  confirmOrder,
};
